import { apiFetch } from "@/lib/api";

export const WIRELESS_DEVICE_REPORT_KEY = "engineering-wireless-device-report";

export interface WirelessDeviceReportResponse {
  query: {
    raw: string;
    field: string;
    term: string;
  };
  identity: {
    imei: string | null;
    iccid: string | null;
    deviceLabelSerial: string | null;
    inferredCarrier: string | null;
    hubSerialFci: {
      id: number;
      deviceLabelSerial: string | null;
      imei: string | null;
      iccid: string | null;
      finishedSku: string | null;
      batchId: number | null;
      shipmentId: number | null;
      archivedAt: string | null;
    } | null;
    hubSim: {
      iccid: string;
      carrier: string;
      isActive: boolean;
    } | null;
  };
  prodWireless: {
    status: string;
    source: string | null;
    message: string | null;
    portalDevice: {
      deviceId: number;
      fciSerial: string | null;
      imei: string | null;
      realName: string | null;
      status: string | null;
      shipmentDate: string | null;
      organizationId: number | null;
    } | null;
    checkinSummary: {
      checkinCount: number;
      firstCheckin: string | null;
      lastCheckin: string | null;
    } | null;
    recentCheckins: Array<{
      recordId: number;
      imei: string;
      checkedInAt: string;
      gpsLat: number | null;
      gpsLong: number | null;
      model: string | null;
    }>;
  };
  devWireless: {
    status: "not_configured";
    message: string;
  };
  carrier: {
    status: string;
    inferredCarrier: string | null;
    message: string | null;
    verizon: {
      configured: boolean;
      queried: boolean;
      device: {
        accountName: string | null;
        connected: boolean | null;
        createdAt: string | null;
        lastConnectionDate: string | null;
        carrierState: string | null;
        servicePlan: string | null;
        deviceIds: {
          mdn: string | null;
          imsi: string | null;
          imei: string | null;
          iccid: string | null;
          msisdn: string | null;
        };
      } | null;
      connectionEvents: Array<{
        occurredAt: string;
        event: string | null;
        mdn: string | null;
        bytesUsed: string | null;
        framedIp: string | null;
      }>;
      error: string | null;
    };
    vodafone: {
      configured: boolean;
      queried: boolean;
      iccid: string | null;
      state: string | null;
      customerServiceProfile: string | null;
      error: string | null;
    };
    att: {
      configured: boolean;
      queried: boolean;
      iccid: string | null;
      imei: string | null;
      status: string | null;
      ratePlan: string | null;
      communicationPlan: string | null;
      error: string | null;
    };
  };
}

export async function fetchWirelessDeviceReport(query: string): Promise<WirelessDeviceReportResponse> {
  const params = new URLSearchParams({ q: query.trim() });
  return apiFetch<WirelessDeviceReportResponse>(`/api/engineering/wireless-device-report?${params.toString()}`);
}
